var $table;
var CharterFilter = {
		pageSize:0, //item count that can be listed in a single page
		pageIndex:0, //current page index
		pageCount:0, //page count that visible under the table
		filter:null,
		depCityName:null,
		arrCityName:null,
		dateRangeMonth:null,
		dateRangeYear:null,
		resultCount:0,
		sortBy: null,
};

$(document).ready(function(){
	
	updateCharterModel();

	TABLE_PAGER.setPage(CharterFilter.pageIndex, CharterFilter.pageCount);
	
	$(".pager-list").on("click","a.page",function(){
		
		var pIndex = parseInt($(this).html()) - 1;		
		CharterFilter.pageIndex = pIndex;
		getPageResult();		
	});
	
	$(".pager-prevnext.prev").click(function(){			
		if(CharterFilter.pageIndex != 0){
			CharterFilter.pageIndex--;
			getPageResult();	
		}			
	});
	
	$(".pager-prevnext.next").click(function(){
		if(CharterFilter.pageCount > CharterFilter.pageIndex+1 ){
			CharterFilter.pageIndex++;
			getPageResult();			
		}		
	});
	
	$( document ).on( "charter_filter_event", function( event , filter) {
		
		if(filter != null && filter.airlines != null){
			CharterFilter.filter = filter.airlines.join();
		}
		CharterFilter.pageIndex = 0;
		
		getPageResult();			
	})
});

function updateCharterModel(){
	$table = $("#spoTable");
	CharterFilter.pageSize = $table.data("pagesize");
	CharterFilter.pageIndex = $table.data("pageindex");
	CharterFilter.pageCount = $table.data("pagecount");
	CharterFilter.depCityName = $('#depCityName').val();
	CharterFilter.arrCityName = $('#arrCityName').val();
	CharterFilter.dateRangeMonth = $('[name=selDateMonth]').val();
	CharterFilter.dateRangeYear = $('[name=selDateYear]').val();
	CharterFilter.resultCount = $table.data("count");
	
	$('#resultTotalSpan').text(CharterFilter.resultCount);

}

function getPageResult(){
	$.ajax({
		url : "/spoList",
		dataType : "html",
		data :{
			selectedPage : CharterFilter.pageIndex,
			airportFilter: CharterFilter.filter,
			selDepAirport:CharterFilter.depCityName,
			selArrAirport:CharterFilter.arrCityName,
			selDateMonth:CharterFilter.dateRangeMonth,
			selDateYear:CharterFilter.dateRangeYear,
            sortBy: CharterFilter.sortBy,

		},
		success : function(data) {
			$("#spoTable").remove();
			if(data){				
				$("#tablesorterspo").append(data);
				updateCharterModel();
				TABLE_PAGER.setPage(CharterFilter.pageIndex, CharterFilter.pageCount);
			} 
		},
		error : function(err){
			$("#spoTable").remove();
		}
	});
}
